/**
 * AppRoutes Component
 * 
 * This component defines all the routes for the application using React Router.
 * It includes routes for public pages, protected user pages, and admin pages.
 */
import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage/Homepage';
import ProductDetail from './pages/ProductDetail/ProductDetail';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import Profile from './pages/Profile/Profile';
import SearchResults from './pages/SearchResults/SearchResults';
import About from './pages/About/About';
import Contacts from './pages/Contacts/Contacts';
import CategoryProducts from './components/CategoryProducts/CategoryProducts';
import AdminLogin from './components/AdminLogin/AdminLogin';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import PrivateRoute from './components/PrivateRoute';
import Orders from './pages/Orders/Orders';

/**
 * AppRoutes component that defines the routing structure of the application
 * Contains:
 * - Public routes (homepage, product details, search, login, signup)
 * - Protected user routes (profile, orders) that require authentication
 * - Admin routes that require admin privileges
 * - Category-specific product listing routes
 */
const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Homepage />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/search" element={<SearchResults />} />
      <Route path="/about" element={<About />} />
      <Route path="/contacts" element={<Contacts />} />
      <Route path="/contact" element={<Navigate to="/contacts" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      
      {/* Protected user routes */}
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <PrivateRoute>
            <Orders />
          </PrivateRoute>
        }
      />
      
      {/* Admin routes */}
      <Route path="/admin" element={<AdminLogin />} />
      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute adminRequired={true}>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      
      {/* Category routes */}
      <Route 
        path="/category/:subcategory" 
        element={<CategoryProducts />} 
      />
    </Routes>
  );
};

export default AppRoutes;
